import guardFace from './guardFace';
import paulFace from './paulFace';

export default {
  guardFace,
  paulFace
};
